import setIn from 'transmute/setIn';
import { useLocation } from 'react-router-dom';
import HistorySingleton from '../../routing/records/HistorySingleton';
import { getVerifyFbmInstall } from '../../verify-fbm-install/operators/getFbmLocationParams';
import VerifyFbmPromptContainer from '../../verify-fbm-install/containers/VerifyFbmPromptContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const location = useLocation();
  const closePrompt = () => {
    const newLocation = setIn(['search'], '', location);
    HistorySingleton().instance().replace(newLocation);
  };
  const pageId = getVerifyFbmInstall(location);
  return {
    pageId,
    closePrompt
  };
};
const InboxVerifyFBMPrompt = () => {
  const {
    pageId,
    closePrompt
  } = InboxVerifyFBMPrompt.useComponent();
  if (pageId) {
    return /*#__PURE__*/_jsx(VerifyFbmPromptContainer, {
      pageId: pageId,
      closePrompt: closePrompt
    });
  }
  return null;
};
InboxVerifyFBMPrompt.displayName = 'InboxVerifyFBMPrompt';
InboxVerifyFBMPrompt.useComponent = useComponent;
export default InboxVerifyFBMPrompt;